import {
  AlignItems,
  Badge,
  Box,
  Text,
  Button,
  Color,
  Display,
  DisplayPosition,
  JustifyContent,
  withCitrusTheme,
  FontWeight,
} from '@gousto-internal/citrus-react'
import React from 'react'

const CustomButton = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

const RecipeCountBadge = withCitrusTheme(Badge, (theme) => ({
  backgroundColor: theme.color(Color.Secondary_600),
  '&[data-disabled]': {
    backgroundColor: theme.color(Color.NeutralGrey_300),
  },
  color: theme.color(Color.White),
  minWidth: theme.spacing(10),
  minHeight: theme.spacing(8),
  display: Display.Flex,
  alignItems: AlignItems.Center,
  justifyContent: JustifyContent.Center,
  borderRadius: theme.spacing(1),
}))

type CheckoutButtonProps = {
  counter: number | string
  disabled?: boolean
  onClick: (e: React.SyntheticEvent) => void
}

export const ViewBasketButton = ({ counter, disabled, onClick }: CheckoutButtonProps) => (
  <CustomButton
    data-testid="view-basket-button"
    disabled={disabled}
    onClick={onClick}
    width="100%"
    height="50px"
  >
    <Box
      position={DisplayPosition.Relative}
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      width="100%"
      paddingRight={12}
    >
      <Text
        fontWeight={FontWeight.Bold}
        style={{
          whiteSpace: 'nowrap',
        }}
      >
        View basket
      </Text>
      <Box
        position={DisplayPosition.Absolute}
        right="-15px"
        top="50%"
        style={{ transform: 'translateY(-50%)' }}
      >
        <RecipeCountBadge data-disabled={disabled ? '' : undefined}>{counter}</RecipeCountBadge>
      </Box>
    </Box>
  </CustomButton>
)
